import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);

  // Check for existing authentication state on initialization
  useEffect(() => {
    const storedAuthState = sessionStorage.getItem('authenticated');

    if (storedAuthState === 'true') {
      setAuthenticated(true);
    }
  }, []);

   // Check for authentication status on page refresh
   useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem('authenticated', authenticated.toString());
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [authenticated]);

  const login = () => {
    setAuthenticated(true);
    sessionStorage.setItem('authenticated', 'true');
    localStorage.removeItem('authenticated');
  };

  const logout = () => {
    setAuthenticated(false);
    sessionStorage.clear();
    localStorage.clear();
  };  




  return (
    <AuthContext.Provider value={{ authenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };